import { useEffect, useState } from "react";

// Yeni deploy algılama: Vite her build'de entry modülünü hash'li isimle üretir
// (index-XXced.js). Açılışta çalışan bundle'ın adını sabitler, periyodik olarak
// canlı index.html'i çekip entry adını karşılaştırır — farklıysa yeni sürüm var.
// Sadece production'da çalışır (dev'de entry /src/main.jsx sabittir).

const entryFromDocument = () => {
  const el = document.querySelector('script[type="module"][src]');
  return el ? new URL(el.src, window.location.origin).pathname : null;
};

const fetchLatestEntry = async () => {
  const res = await fetch("/index.html", { cache: "no-store" });
  if (!res.ok) {
    return null;
  }
  const html = await res.text();
  const match = html.match(/<script[^>]+type="module"[^>]+src="([^"]+)"/i);
  return match ? new URL(match[1], window.location.origin).pathname : null;
};

export const useAppVersion = (intervalMs = 5 * 60 * 1000) => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    if (!import.meta.env.PROD) {
      return undefined;
    }

    const baseline = entryFromDocument();
    if (!baseline) {
      return undefined;
    }

    let stopped = false;
    const check = async () => {
      const latest = await fetchLatestEntry().catch(() => null);
      if (!stopped && latest && latest !== baseline) {
        setUpdateAvailable(true);
      }
    };

    const onVisible = () => document.visibilityState === "visible" && check();

    const id = setInterval(check, intervalMs);
    document.addEventListener("visibilitychange", onVisible);
    check();

    return () => {
      stopped = true;
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [intervalMs]);

  return updateAvailable;
};
